var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 19.5494V19.7994H9H11.75V29.4654C5.17384 27.9766 0.25 22.0884 0.25 15.0381C0.25 6.87481 6.85866 0.250488 15 0.250488C23.1413 0.250488 29.75 6.87481 29.75 15.0381C29.75 22.6186 24.066 28.8569 16.75 29.7218V19.7994H21H21.25V19.5494V15.0381V14.7881H21H16.75V12.0306C16.75 11.341 17.3137 10.7768 18 10.7768H21H21.25V10.5268V6.01553V5.76553H21H17.25C14.2163 5.76553 11.75 8.23895 11.75 11.2787V14.7881H9H8.75V15.0381V19.5494Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.41a8528d65acbc3c7e168c535cd05470.svg";
export { ForwardRef as ReactComponent };